import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { impressumContent, datenschutzContent, barrierefreiheitContent } from '../data/mock';

const LegalPage = () => {
  const location = useLocation();
  
  // Determine which content to show based on route
  const getContent = () => {
    switch (location.pathname) {
      case '/impressum':
        return impressumContent;
      case '/datenschutz':
        return datenschutzContent;
      case '/barrierefreiheit':
        return barrierefreiheitContent;
      default:
        return impressumContent;
    }
  };
  
  const content = getContent();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_agency-dashboard-38/artifacts/ve9u3f19_logo_sharp_4x%20%281%29.png" 
                alt="Autogutachter24 Logo" 
                className="h-8 object-contain"
              />
            </Link>
            <Link to="/">
              <Button variant="ghost" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                <ArrowLeft className="w-4 h-4" />
                Zurück zur Anmeldung
              </Button>
            </Link>
          </div>
        </div>
      </header>
      
      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-lg shadow-gray-200/50 p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            {content.title}
          </h1>
          
          <div className="space-y-8">
            {content.sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-xl font-semibold text-gray-800 mb-3">
                  {section.heading}
                </h2>
                <p className="text-gray-600 leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
        
        {/* Footer Navigation */}
        <div className="mt-8 text-center">
          <div className="flex items-center justify-center gap-4 text-sm text-gray-500">
            <Link 
              to="/impressum" 
              className={`hover:text-blue-600 transition-colors ${location.pathname === '/impressum' ? 'text-blue-600 font-medium' : ''}`}
            >
              Impressum
            </Link>
            <span className="text-gray-300">•</span>
            <Link 
              to="/datenschutz" 
              className={`hover:text-blue-600 transition-colors ${location.pathname === '/datenschutz' ? 'text-blue-600 font-medium' : ''}`}
            >
              Datenschutz
            </Link>
            <span className="text-gray-300">•</span>
            <Link 
              to="/barrierefreiheit" 
              className={`hover:text-blue-600 transition-colors ${location.pathname === '/barrierefreiheit' ? 'text-blue-600 font-medium' : ''}`}
            >
              Barrierefreiheit
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
